/**
 * DIEUKYDIEU.TV - EXPLORE & CATEGORY DETAIL VIEW MODULE
 */
import { t } from './i18n.js';
import { enableSmoothHorizontalInteraction } from './ui.js';
import { renderExploreSpotlight } from './spotlight.js';
import { createCardElement, renderChipHTML, setActiveChip } from './components/index.js';
import { initChipScroll } from './chip-scroll.js';
import {
    FALLBACK_SITEMAP_DATA,
    getSectionsData,
    getSitemapTree,
    loadExploreDataAsync,
    MASTER_BANNERS,
    REFERENCE_NETWORK_LINKS,
    renderMasterBanners,
    renderReferenceNetworkGrid
} from './modules/explore-data.js';

export {
    FALLBACK_SITEMAP_DATA,
    getSectionsData,
    getSitemapTree,
    loadExploreDataAsync,
    MASTER_BANNERS,
    REFERENCE_NETWORK_LINKS,
    renderMasterBanners,
    renderReferenceNetworkGrid
};

export {
    currentDetailCategory,
    currentDetailTreeCategory,
    selectedTier1,
    selectedTier2,
    currentCategoryArticles,
    filteredCategoryArticles,
    categoryCurrentPage,
    categoryPageSize,
    openCategoryBySlug,
    closeCategoryDetail,
    renderTier1Chips,
    onSelectTier1,
    renderTier2Chips,
    expandTier2Accordion,
    collapseTier2Accordion,
    onSelectTier2,
    applyCategoryFilters
} from './modules/explore-detail.js';

export {
    updateFilterStatusBar,
    renderCategoryArticlesGrid,
    updatePaginationAndInfiniteScroll,
    loadMoreCategoryArticles,
    goToCategoryPage,
    setupCategoryInfiniteScroll
} from './modules/explore-grid.js';

import { currentDetailCategory, openCategoryBySlug } from './modules/explore-detail.js';

let isExploreLoaded = false;

export async function hydrateExploreFromApi() {
    try {
        const { sections } = await loadExploreDataAsync();
        if (Array.isArray(sections) && sections.length > 0) {
            renderExploreSections();
            if (currentDetailCategory) {
                openCategoryBySlug(currentDetailCategory.slug || currentDetailCategory.id, false);
            }
        }
    } catch (_) {}
}

export function renderExploreSections() {
    if (!isExploreLoaded) {
        isExploreLoaded = true;
        hydrateExploreFromApi();
    }
    renderMasterBanners();
    if (typeof renderExploreSpotlight === 'function') {
        renderExploreSpotlight();
    }
    renderReferenceNetworkGrid();

    const container = document.getElementById('explore-sections-container');
    if (!container) return;
    container.innerHTML = '';

    const sections = getSectionsData();
    const tree = getSitemapTree();

    sections.forEach((sec) => {
        const secCard = document.createElement('section');
        secCard.className = 'category-section';
        secCard.setAttribute('data-section-id', sec.id);
        secCard.setAttribute('data-slug', sec.slug);

        const secName = t('sec_' + sec.id) || sec.name;

        // Tree matching for subcategory chips
        const treeCat = tree.find(t => t.id === sec.id || t.slug === sec.slug) || sec;
        const subCategories = (treeCat && treeCat.children) || sec.children || [];

        let subchipsHtml = '';
        if (subCategories.length > 0) {
            let chipsListHtml = renderChipHTML({
                id: 'all',
                label: 'Tất cả',
                isActive: true,
                variant: 'subchip',
                legacyClass: 'sec-subchip',
                staggerIndex: 0
            });
            subCategories.forEach((child, idx) => {
                chipsListHtml += renderChipHTML({
                    id: child.name || child.id,
                    label: child.name,
                    isActive: false,
                    variant: 'subchip',
                    legacyClass: 'sec-subchip',
                    staggerIndex: idx + 1
                });
            });
            subchipsHtml = `
                <div class="sec-subchips-wrapper chip-scroll-wrapper" role="region" aria-label="Bộ lọc nhanh ${secName}">
                    <div class="sec-subchips-scroll chip-scroll-track" role="tablist">
                        ${chipsListHtml}
                    </div>
                </div>
            `;
        }

        const headerHtml = `
            <div class="category-header">
                <h2 onclick="openCategoryBySlug('${sec.slug}')" title="${secName}">
                    <span>${secName}</span>
                </h2>
                <a href="/category/${sec.slug}" class="view-more-category-btn" onclick="event.preventDefault(); openCategoryBySlug('${sec.slug}')" aria-label="${t('view_more')} - ${secName}">
                    <span>${t('view_more')}</span>
                    <span class="material-symbols-rounded">chevron_right</span>
                </a>
            </div>
            ${subchipsHtml}
        `;

        secCard.innerHTML = `
            ${headerHtml}
            <div class="category-horizontal-scroll" id="scroll-row-${sec.id}" role="region" aria-label="Danh sách bài viết ${sec.name}">
            </div>
        `;

        const scrollRow = secCard.querySelector('.category-horizontal-scroll');

        const populateCards = (articlesList) => {
            if (!scrollRow) return;
            scrollRow.innerHTML = '';
            articlesList.forEach((art, idx) => {
                const cardEl = createCardElement({
                    id: art.id,
                    title: art.title,
                    desc: art.desc,
                    img: art.img,
                    badge: (idx === 0) ? 'Mới' : '',
                    variant: 'editorial',
                    legacyClass: 'article-card preview-card',
                    onClick: () => {
                        if (typeof window.openStoryDetail === 'function') {
                            window.openStoryDetail(art);
                        }
                    }
                });
                scrollRow.appendChild(cardEl);
            });
            enableSmoothHorizontalInteraction(scrollRow);
        };

        const defaultArticles = (sec.articles || []).slice(0, 5);
        populateCards(defaultArticles);

        // Subchip click listeners
        const subchipsTrack = secCard.querySelector('.sec-subchips-scroll');
        const subchipBtns = secCard.querySelectorAll('.sec-subchip');
        subchipBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                if (subchipsTrack) {
                    setActiveChip(subchipsTrack, btn, '.sec-subchip');
                }
                const filterVal = btn.getAttribute('data-id') || btn.getAttribute('data-filter');
                if (filterVal === 'all') {
                    populateCards(defaultArticles);
                } else {
                    const target = (filterVal || '').toLowerCase().trim();
                    const filtered = (sec.articles || []).filter(a => {
                        const tag = (a.tag || '').toLowerCase().trim();
                        const pTag = (a.parentTag || '').toLowerCase().trim();
                        return tag === target || pTag === target;
                    });
                    populateCards(filtered.length > 0 ? filtered : defaultArticles);
                }
            });
        });

        container.appendChild(secCard);

        const subchipsWrapper = secCard.querySelector('.sec-subchips-wrapper');
        if (subchipsWrapper) {
            initChipScroll(subchipsWrapper);
        }
    });

}

